import React, { useMemo } from "react";
import { isPuttable } from "./utils/is-puttable";
import { useWorldContext } from "../hooks/use-world-context";
import { Block, Pointer } from "./styled";
export const Entity = ({ data, x, y, active, onPut }) => {
    const world = useWorldContext();
    const puttable = useMemo(() => (active && isPuttable(world, x, y)), [world, active]);
    return (React.createElement(Block, { entity: data, allow: puttable, onClick: puttable ? onPut : undefined }, puttable && React.createElement(Pointer, null)));
};
